<script lang="ts">
  import { t } from "../../../../core";
  export let title: string;
  export let description: string = "";
  export let submit: string;
  export let isLoading: boolean;
  export let isDisabled: boolean;
  export let isSuccess: boolean = false;
</script>

<div class="form-top-block">
  {#if title}
    <div class="form-title">{title}</div>
  {/if}

  {#if description}
    <div class="form-desc">{description}</div>
  {/if}
</div>

<slot />

<div class="form-submit-block">
  {#if submit && !isSuccess}
    <button class="btn" disabled={isLoading || isDisabled} on:click>
      {isLoading ? `${t("General.Loading.Title")}` : submit}
    </button>
  {/if}

  <div class="form-forgot-link">
    <slot name="link" />
  </div>
</div>

<style lang="scss">
  .form-top-block {
    margin-bottom: 20px;
  }

  .form-title {
    @include h2;
    margin-bottom: 10px;
  }

  .form-desc {
    @include normal;
    margin-bottom: 15px;
  }

  .form-submit-block {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  .form-forgot-link {
    @include small;
  }
</style>
